import { useParams, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import HelpTOC from '../components/help/HelpTOC'
import HelpContent from '../components/help/HelpContent'

const DEFAULT_SECTION = 'quick-start'

export default function Help() {
  const { section } = useParams()
  const { t } = useTranslation()

  // No :section param — redirect to the default landing section so every
  // visible section has a canonical URL.
  if (!section) {
    return <Navigate to={`/help/${DEFAULT_SECTION}`} replace />
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">{t('help.pageTitle')}</h1>

      {/* Two-pane layout — stacks on mobile, side-by-side on md+ */}
      <div className="flex flex-col md:flex-row md:gap-8">
        <aside className="md:w-64 md:flex-shrink-0 mb-6 md:mb-0">
          <HelpTOC currentSection={section} />
        </aside>
        <section className="flex-1 min-w-0">
          <HelpContent section={section} />
        </section>
      </div>
    </div>
  )
}
